export const ITEM_TYPE = {
  NOTE: 'NOTE',
  FILE_NOTE: 'FILE_NOTE',
  KEYPOINT: 'KEYPOINT',
} as const;
